export enum CreditoTomadorBaseCalculoEnum {

  BASE_CALCULO_NOTA = "Base de cálculo da nota",
  IMPOSTO_GERADO = "Imposto Gerado",
  VALOR_BRUTO_NOTA = "Valor Bruto da Nota",
  VALOR_LIQUIDO_NOTA = "Valor líquido da Nota"
}
